(() => {
  const params = new URLSearchParams(window.location.search);
  const source = params.get('rsg_pack_source');
  if (!['fuel_pack', 'guide_fuel_packs'].includes(source)) return;

  const handoff = document.querySelector('[data-rsg-fuel-pack-handoff]');
  if (handoff) {
    const eventLabel = params.get('rsg_pack_label') || 'selected duration';
    const brand = params.get('rsg_brand');
    const copy = handoff.querySelector('[data-rsg-fuel-pack-handoff-copy]');
    if (copy) copy.textContent = `We have carried across ${eventLabel}${brand ? ` and your ${brand} preference` : ''}. Check the activity, time, conditions and product choices before continuing.`;
    handoff.hidden = false;
  }

  const setValue = (form, name, value) => {
    const field = form.querySelector(`[name="${CSS.escape(name)}"]`);
    if (!field || value === null || value === '') return;
    field.value = value;
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const prefill = (root) => {
    const prefillState = root.dataset.rsgFuelPackPrefillState;
    if (prefillState === 'pending' || prefillState === 'applied') return true;
    const start = root.querySelector('[data-rsg-action="start-race-day"]');
    if (!start) return false;
    root.dataset.rsgFuelPackPrefillState = 'pending';
    const apply = () => {
      const form = root.querySelector('form[data-rsg-step="event"]');
      if (!form) return false;
      const activity = params.get('rsg_activity_type');
      setValue(form, 'activityType', ['run', 'cycle', 'triathlon', 'other'].includes(activity) ? activity : 'other');
      setValue(form, 'distance', params.get('rsg_distance_km'));
      setValue(form, 'distanceUnit', 'km');
      const hours = Number(params.get('rsg_duration_hours') || 0);
      if (hours > 0) {
        setValue(form, 'expectedFinishHours', String(Math.floor(hours)));
        setValue(form, 'expectedFinishMinutes', String(Math.round((hours % 1) * 60)));
      }
      const brandMap = { STYRKR: 'Styrkr' };
      const brand = brandMap[params.get('rsg_brand')] || params.get('rsg_brand');
      if (brand) {
        form.querySelectorAll('input[name="selectedBrands"]').forEach((input) => {
          input.checked = input.value === brand;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      form.querySelector('[name="activityType"]')?.focus({ preventScroll: true });
      root.dataset.rsgFuelPackPrefillState = 'applied';
      return true;
    };
    try {
      start.click();
    } catch (_error) {
      delete root.dataset.rsgFuelPackPrefillState;
      return false;
    }
    if (apply()) return true;
    const observer = new MutationObserver(() => { if (apply()) observer.disconnect(); });
    observer.observe(root, { childList: true, subtree: true });
    window.setTimeout(() => {
      observer.disconnect();
      if (root.dataset.rsgFuelPackPrefillState === 'pending') {
        delete root.dataset.rsgFuelPackPrefillState;
      }
    }, 30000);
    return true;
  };

  const initialise = () => {
    const root = document.querySelector('[id^="rsg-fuel-finder-root"]');
    if (root && prefill(root)) return;
    const observer = new MutationObserver(() => {
      const nextRoot = document.querySelector('[id^="rsg-fuel-finder-root"]');
      if (nextRoot && prefill(nextRoot)) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 30000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('rsg:fuel-finder-runtime-ready', initialise);
})();
